// import getConfig from 'next/config';

// const config = getConfig();
// let publicRuntimeConfig: any = {};
// if (config && config.publicRuntimeConfig) {
//     publicRuntimeConfig = config.publicRuntimeConfig;
// }

const IS_IN_PRODUCTION_MODE = process.env.NEXT_PUBLIC_NODE_ENV === 'production';
const BASE_DEPLOY_PATH = process.env.NEXT_PUBLIC_BASE_DEPLOY_PATH ?? '';

const environments = {
    // build-time configs
    BASE_DEPLOY_PATH,
    IS_IN_PRODUCTION_MODE,
    CLIENT_SIDE_ENDPOINT_HOST: process.env.NEXT_PUBLIC_CLIENT_SIDE_API_ENDPOINT_HOST || '',
    SERVER_SIDE_ENDPOINT_HOST: process.env.SERVER_SIDE_API_ENDPOINT_HOST,
    API_KEY: process.env.NEXT_PUBLIC_API_KEY,
    NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
    VIRTUAL_HOST: process.env.VIRTUAL_HOST ?? 'http://localhost:8080',
    DOCUMENT_EXTRACT_IS_ENABLE: process.env.NEXT_PUBLIC_DOCUMENT_EXTRACT_IS_ENABLE ?? false,
    ANNOTATOR_API: process.env.ANNOTATOR_API,
    MAX_FILE_SIZE: process.env.NEXT_PUBLIC_MAX_FILE_SIZE ?? 250 * 1024 * 1024,
    DATA_WEBSITE_ID: process.env.NEXT_PUBLIC_DATA_WEBSITE_ID,
    STANDARD_PLAN_PRICE_ID: process.env.NEXT_PUBLIC_STANDARD_PLAN_PRICE_ID,
    STARTER_PLAN_PRICE_ID: process.env.NEXT_PUBLIC_STARTER_PLAN_PRICE_ID,
    PREMIUM_PLAN_PRICE_ID: process.env.NEXT_PUBLIC_PREMIUM_PLAN_PRICE_ID,
    FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL,
    IS_SINGLE_TENANT: !(process.env.NEXT_PUBLIC_IS_SINGLE_TENANT == 'false'),
    SUBSCRIPTION_API_URL: process.env.NEXT_PUBLIC_SUBSCRIPTION_API_URL,
    ENABLE_GOOGLE_ANALYTICS: process.env.NEXT_PUBLIC_ENABLE_GOOGLE_ANALYTICS,
    GOOGLE_ANALYTICS_TAG: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TAG,
    KEYCLOAK_CALLBACK_URL: process.env.NEXT_PUBLIC_KEYCLOAK_CALLBACK_URL,
    CHATWOOT_BASE_URL: process.env.NEXT_PUBLIC_CHATWOOT_BASE_URL,
    CHATWOOT_WEBSITE_TOKEN: process.env.NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN,
    IS_CHATWOOT_ENABLED: process.env.NEXT_PUBLIC_IS_CHATWOOT_ENABLED
};

export default environments;
